export default __webpack_public_path__ + "static/media/send-round-1569.56c26949.svg";